import { NavLink } from "react-router-dom";
import { useNavePagesItems } from "../../../hooks/useNavPagesItems";
import { Ripple } from "primereact/ripple";

const PagesNav = () => {
  const navPagesItems = useNavePagesItems();

  return (
    <div className="flex md:flex-row flex-column gap-1">
      {navPagesItems.map((item) => (
        <NavLink
          to={item.url}
          key={item.url}
          className={({ isActive }) =>
            `nav-item no-underline flex align-items-center gap-2 p-ripple ${
              isActive ? "active-link" : ""
            }`
          }
        >
          <i className={`${item.icon} text-lg`} />
          <span className="text-base">{item.name}</span>
          <Ripple />
        </NavLink>
      ))}
    </div>
  );
};

export default PagesNav;
